/**
 * Updates the document title with an optional section name
 * @param {string} title - The section title to append
 */
export const updateDocumentTitle = (title) => {
  const prefix = 'CellCog';
  document.title = title ? `${prefix} - ${title}` : prefix;
};
